import { XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
  closeHandler: () => void;
  hide?: boolean;
}
export default function DashboardMessage({
  closeHandler,
  hide = false,
}: Props) {
  return !hide ? (
    <div className="fixed inset-x-0 bottom-0 flex flex-col justify-between gap-x-8 gap-y-4 bg-amber-500 p-6 ring-1 ring-gray-900/10 md:flex-row md:items-center lg:px-16 z-50">
      <p className="max-w-8xl text-sm text-white font-medium">
        Every month, your store receives the monthly promotion communication
        package, delivered approximately two weeks before the promotion starts.
        In case visuals are missing and/or damaged, you can re-order the visuals
        via this online order portal (ROBIN portal). This online order portal
        will open on the Wednesday 1,5 week prior to the start of the promotion
        and closes Tuesday, the day after the start of the promotion. Exact
        opening and closing dates for the portal will be shared in the
        newsletter.
      </p>
      <div className="flex flex-1 justify-end">
        <button
          type="button"
          onClick={closeHandler}
          className="-m-3 p-3 focus-visible:outline-offset-[-4px]"
        >
          <XMarkIcon aria-hidden="true" className="h-6 w-6 text-white" />
        </button>
      </div>
    </div>
  ) : null;
}
